import { Box } from "@mantine/core";

export default function AppContainer({ children }) {
  return (
    <Box
      sx={{
        padding: "20px",
      }}
    >
      {children}
    </Box>
  );
}
